import { useEffect, useState } from "react";
import { getAllEventPartners } from "../api/eventpartners";

const EventPartners = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    getAllEventPartners()
      .then((res) => {
        setPartners(res?.data?.topics || []);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  if (!partners.length) {
    return null;
  }

  return (
    <section className="event-partners-section pt-0 pb-5">
      <div className="container">
        <div className="event-partners-shell">
          <div className="event-partners-heading text-center">
            <h2 className="event-partners-title mb-0">
              Some of our Recent
              <span className="d-block">
                <span className="event-partners-highlight">Events</span>{" "}
                Sponsors
              </span>
            </h2>
            <p className="event-partners-copy mb-0">
              Featured partner logos from our recent event ecosystem.
            </p>
          </div>

          <div className="event-partners-grid">
            {partners.map((partner, index) => {
              const CardTag = partner?.details ? "a" : "div";

              return (
                <CardTag
                  key={`${partner?.id || partner?.title || "partner"}-${index}`}
                  {...(partner?.details
                    ? {
                        href: partner.details,
                        target: "_blank",
                        rel: "noopener noreferrer",
                      }
                    : {})}
                  className="event-partners-card"
                >
                  <img
                    src={partner?.photo_file}
                    alt={partner?.title || "Event partner"}
                  />
                </CardTag>
              );
            })}
          </div>

         
        </div>
      </div>
    </section>
  );
};

export default EventPartners;
